/**
 * Normalize a language label/code coming from the API or the browser into one of the supported app language codes.
 *
 * @param language Raw language label or code
 * @returns Supported language code ('fr', 'en', 'de', 'es' or 'zh')
 */
export function normalizeLanguage(language?: string): string {
    const normalizedLanguage = (language ?? '').toLowerCase().replace('_', '-');

    if (normalizedLanguage.startsWith('en')) {
        return 'en';
    }
    if (normalizedLanguage.startsWith('de')) {
        return 'de';
    }
    if (normalizedLanguage.startsWith('es')) {
        return 'es';
    }
    if (normalizedLanguage.startsWith('zh')) {
        return 'zh';
    }

    return 'fr';
}
